export var EInvoiceStatus;
(function (EInvoiceStatus) {
    EInvoiceStatus["ANY"] = "any";
    // bill created, awaits processing
    EInvoiceStatus["PENDING"] = "pending";
    // bill paid
    EInvoiceStatus["PAID"] = "paid";
    // auto rescue failed
    EInvoiceStatus["UNPAID"] = "unpaid";
    // payment request failed
    EInvoiceStatus["ERROR"] = "error";
    // payment request refunded (for invoices)
    EInvoiceStatus["REFUNDED"] = "refunded";
    // payment process started
    EInvoiceStatus["TRIGGERED"] = "triggered";
    // payment requested, awaits webhook
    EInvoiceStatus["PROCESSING"] = "processing";
    // awaits action
    EInvoiceStatus["ACTION_AWAIT"] = "action_await";
    // authorised, awaits capture
    EInvoiceStatus["AUTHORIZED"] = "authorized";
    // auto rescue failed, retrying
    EInvoiceStatus["RETRYING"] = "retrying";
    // payment request refund triggered (for invoices)
    EInvoiceStatus["REFUND_TRIGGERED"] = "refund_triggered";
    // payment request partially refunded (for invoices)
    EInvoiceStatus["PARTIALLY_REFUNDED"] = "partially_refunded";
    // payment request partially refund triggered (for invoices)
    EInvoiceStatus["PARTIALLY_REFUND_TRIGGERED"] = "partially_refund_triggered";
    EInvoiceStatus["PARTIALLY_PAID"] = "partially_paid";
})(EInvoiceStatus || (EInvoiceStatus = {}));
export var EInvoiceStatusFilter;
(function (EInvoiceStatusFilter) {
    EInvoiceStatusFilter["ANY"] = "any";
    EInvoiceStatusFilter["PAID"] = "paid";
    EInvoiceStatusFilter["REFUNDED"] = "refunded,partially_refunded,refund_triggered,partially_refund_triggered";
    EInvoiceStatusFilter["UNPAID"] = "unpaid,error,triggered,processing,action_await,authorized,retrying,pending";
})(EInvoiceStatusFilter || (EInvoiceStatusFilter = {}));
export var EpartnerBillingSystem;
(function (EpartnerBillingSystem) {
    EpartnerBillingSystem["BOLETO"] = "boleto";
    EpartnerBillingSystem["PIX"] = "pix";
    EpartnerBillingSystem["STRIPE"] = "stripe";
    EpartnerBillingSystem["PBS"] = "pbs";
    EpartnerBillingSystem["BANK_TRANSFER"] = "bank_transfer";
})(EpartnerBillingSystem || (EpartnerBillingSystem = {}));
export var PaymentPlatform;
(function (PaymentPlatform) {
    PaymentPlatform["STRIPE"] = "stripe";
    PaymentPlatform["ADYEN"] = "adyen";
    PaymentPlatform["EBANX"] = "ebanx";
})(PaymentPlatform || (PaymentPlatform = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGFydG5lcnMudHlwZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJwYXJ0bmVycy50eXBlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFzQkEsTUFBTSxDQUFOLElBQVksY0E2Qlg7QUE3QkQsV0FBWSxjQUFjO0lBQ3hCLDZCQUFXLENBQUE7SUFDWCxrQ0FBa0M7SUFDbEMscUNBQW1CLENBQUE7SUFDbkIsWUFBWTtJQUNaLCtCQUFhLENBQUE7SUFDYixxQkFBcUI7SUFDckIsbUNBQWlCLENBQUE7SUFDakIseUJBQXlCO0lBQ3pCLGlDQUFlLENBQUE7SUFDZiwwQ0FBMEM7SUFDMUMsdUNBQXFCLENBQUE7SUFDckIsMEJBQTBCO0lBQzFCLHlDQUF1QixDQUFBO0lBQ3ZCLG9DQUFvQztJQUNwQywyQ0FBeUIsQ0FBQTtJQUN6QixnQkFBZ0I7SUFDaEIsK0NBQTZCLENBQUE7SUFDN0IsNkJBQTZCO0lBQzdCLDJDQUF5QixDQUFBO0lBQ3pCLCtCQUErQjtJQUMvQix1Q0FBcUIsQ0FBQTtJQUNyQixrREFBa0Q7SUFDbEQsdURBQXFDLENBQUE7SUFDckMsb0RBQW9EO0lBQ3BELDJEQUF5QyxDQUFBO0lBQ3pDLDREQUE0RDtJQUM1RCwyRUFBeUQsQ0FBQTtJQUN6RCxtREFBaUMsQ0FBQTtBQUNuQyxDQUFDLEVBN0JXLGNBQWMsS0FBZCxjQUFjLFFBNkJ6QjtBQUVELE1BQU0sQ0FBTixJQUFZLG9CQUtYO0FBTEQsV0FBWSxvQkFBb0I7SUFDOUIsbUNBQVcsQ0FBQTtJQUNYLHFDQUFhLENBQUE7SUFDYiw0R0FBb0YsQ0FBQTtJQUNwRiw2R0FBcUYsQ0FBQTtBQUN2RixDQUFDLEVBTFcsb0JBQW9CLEtBQXBCLG9CQUFvQixRQUsvQjtBQWkzQkQsTUFBTSxDQUFOLElBQVkscUJBTVg7QUFORCxXQUFZLHFCQUFxQjtJQUMvQiwwQ0FBaUIsQ0FBQTtJQUNqQixvQ0FBVyxDQUFBO0lBQ1gsMENBQWlCLENBQUE7SUFDakIsb0NBQVcsQ0FBQTtJQUNYLHdEQUErQixDQUFBO0FBQ2pDLENBQUMsRUFOVyxxQkFBcUIsS0FBckIscUJBQXFCLFFBTWhDO0FBRUQsTUFBTSxDQUFOLElBQVksZUFJWDtBQUpELFdBQVksZUFBZTtJQUN6QixvQ0FBaUIsQ0FBQTtJQUNqQixrQ0FBZSxDQUFBO0lBQ2Ysa0NBQWUsQ0FBQTtBQUNqQixDQUFDLEVBSlcsZUFBZSxLQUFmLGVBQWUsUUFJMUIifQ==